
export const products=[
    {
        id: 1,
        alt: "Crypto-World",
        img: "https://i.ibb.co/KXpJFTY/cryptoworld.jpg",
        link:"https://github.com/pananon/crypto-world",
    },
    {
        id: 2,
        alt: "My Portfolio",
        img: "https://i.ibb.co/dmWT2MS/myportfolio.jpg",
        link:"https://divinecoded.netlify.app/",
    },
    {
        id: 3,
        alt: "RushTheBox",
        img: 'https://i.ibb.co/9vMnr7d/Unity-Game.png',
        link:"https://github.com/pananon/UnityGameRushBox",
    },
    // {
    //     id: 4,
    //     alt: "Codechef",
    //     img: "https://i.giphy.com/media/zMukICnMEZmSf8zvXd/200w.webp",
    //     link:"https://www.codechef.com/users/pandey01",
    // },
    // {
    //     id: 5,
    //     alt: "Chess",
    //     img: "https://i.giphy.com/media/9POMmQiLkvhRzKFXyT/giphy.webp",
    //     link:"https://www.chess.com/member/harimangalp1",
    // },
    // {
    //     id: 6,
    //     alt: "Trading Profile",
    //     img: "https://i.giphy.com/media/50OuNGJcwIVXcuJURc/giphy.webp",
    //     link:"https://in.tradingview.com/u/pananon7/",
    // },
]